import React from "react";
import styled from "styled-components";

    const Title = styled.h2`
    color: white;
    text-align: center;
    font-size: 25px;
  `

  const MainDiv = styled.div
  `
  position: absolute;
  right: 5%;
  `
  
  const Bar = styled.div`
    position: relative;
    height: 300px;
    width: 30px;
    border-radius: 3px;
    border: 1px solid #ccc;
    margin: 1rem auto;
  `
  
  const Fill = styled.div`
    background: #0095da;
    height: ${(props) => `${props.percentage}%`};
    border-radius: inherit;
    transition: width .2s ease-in;
    width: 100%};
  `
  
  const ProgressBar = ({ percentage }) => {
    
    return (
      <MainDiv>
        <Title style={{userSelect: "none"}}>Power</Title>
        <Bar>
          <Fill percentage={`${Math.round(percentage)}`} />
        </Bar>
      </MainDiv>
    );
  }

export default ProgressBar;